import { createBrowserHistory } from 'history'

const BrowserHistory = createBrowserHistory()
export default BrowserHistory
